import SmallBadge from './SmallBadge';
export default SmallBadge;
